<template lang="pug">
  v-container(fluid)
    //- h2.text-center {{ translations.title }}
    h2.text-center Opt-In
    v-row.px-2.px-sm-10.pb-10
      v-col(cols="12" sm="6" md="4")
        BaseChipSelectField(:multiple="false", :items="operatorsListAll" v-model="operator", label="Operador")
    v-row.px-2.px-sm-10.pb-10
      v-col(cols="12")
        v-data-table(
          :headers="headers"
          :items="datos"
          :items-per-page="30"
          :footer-props="{'items-per-page-options': [10, 20, 30, 40, 50], 'itemsPerPageText': $t('api.datatable.rowsperpage')}"
        )
          template(v-slot:item="{ item }")
            tr
              td
                span {{ item.id }}
              td
                span {{ item.startdate }}
              td
                span {{ item.registered }}
              td
                BaseDetailDialog(button="Ver detalles", :title="'Inscritos en la campaña: ' + item.id")
                  BaseDefinitionList(:items="getDetails(item)" keysAlign="text-left text-sm-right")
                  v-btn(color="green light-1" text)
                    span descargar CSV
                    v-icon.ml-4 mdi-download
              td
                BaseConfirmDialog(v-bind="translations.confirmationDialog.status" @confirm="toggleState(item.id)")
                  template(v-slot="{ on }")
                    v-btn(v-on="on", :color="getColor(item.status.value)", :loading="loadingToggleOptin" dark rounded) {{ item.status.text }}
      v-col(cols="12")
        v-alert( color="blue-grey" dark) pendiente hacer la llamada con usando el id del operador

    BaseDialog(v-if="hasPermission('views.casino.freerounds.createFreerounds')" type="create", title="Crear campaña Opt-In" v-slot="{close, opened}")
      OptinCreate(@successCreate="updateOptin(opened,close)", :clearForm="opened", :translations="translationsForm")

</template>

<script>

  import OptinCreate from '@/components/forms/OptinCreate';
  import FreeroundsEditDialog from '@/components/dialogs/edit/FreeroundsEditDialog';

  export default {
    name: "OptInIndex",
    components: {
      OptinCreate,
      FreeroundsEditDialog,
    },
    data: () => ({
      operator: null,
    }),
    computed:{
      translations() {
        return this.$t("views.freeroundsIndex");
      },
      translationsForm() {
        return this.$t("forms.freerounds");
      },
      headers() {
        let headers = [
          {
            text: 'Id',
            value: 'id'
          },
          {
            text: 'Fecha inicio',
            value: 'startdate'
          },
          {
            text: 'Número inscritos',
            value: 'size'
          },
          {
            text: '',
            value: 'details',
            sortable: false
          },
          {
            text: '',
            value: 'status',
            sortable: false
          },
        ];
        return headers;
      },
      datos(){
        // const vm = this;
        // return this.competitionListAll.map(competition =>{
        //   return {
        //     _id: competition._id,
        return [
          {
            id: '123',
            username: 'test A',
            startdate: '01/10/2020',
            // enddate: vm.$moment(user.cat).format('DD/MM/YYYY HH:mm'),
            registered: 40,
            provider: 'Mondo',
            source: 'Fuente 1',
            status: {
              text: 'Enabled',
              value: 1
            }
          },
          {
            id: '456',
            username: 'test B',
            startdate: '25/10/2020',
            // enddate: vm.$moment(user.cat).format('DD/MM/YYYY HH:mm'),
            registered: 60,
            provider: 'Mondo',
            source: 'Fuente 2',
            status: {
              text: 'Enabled',
              value: 1
            }
          }]
      },
      loadingToggleOptin(){
        return this.$store.state.statusCode.toggleOptin.loading;
      },
      statusToggleState(){
        return this.$store.state.statusCode.toggleOptin.state || '';
      },
      operatorsListAll() {
        return this.$store.state.operators.map(operator => ({
          text:operator.n,
          value:operator._id
        })).sort((a, b) => a.text.localeCompare(b.text));
      },
      optinListAll() {
        return this.$store.state.optin;
      },
    },
    watch: {
      statusToggleState: function (val) {
        if (val == 200) {
          this.$store.dispatch('getOptin');
        }
      },
    },
    created(){
      this.$store.dispatch('getOperators');
      this.$store.dispatch('getOptin');
    },
    methods: {
      getColor(type){
        return type ? 'green': 'red';
      },
      toggleState(optinId){
        this.$store.dispatch('toggleOptin', optinId);
      },
      getDetails(item){
        return [
          {
            // key: this.translations.dialog.details.labels.name,
            key: 'Nombre de usuario',
            value: item.username
          },
          {
            key: 'Fecha de inscriptción',
            value: item.startdate
          },
          {
            key: 'Source',
            value: item.source
          },
        ];
      },
      updateOptin(opened, closedialog){
        if(opened) {
          if(closedialog != undefined){
            closedialog();
          }
          this.$store.dispatch('getOptin');
        }
      },
    },
  }
</script>

<style lang="sass">
</style>